import { useCallback, useMemo } from 'react'

import { useCopyToClipboard } from 'usehooks-ts'

export const useCopyLink = () => {
	const [copiedText, copy] = useCopyToClipboard()

	const handleLinkShare = useCallback(() => copy(window.location.href), [copy])

	return useMemo(
		() => ({
			isCopied: Boolean(copiedText),
			handleLinkShare
		}),
		[copiedText, handleLinkShare]
	)
}
